import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep border-t border-primary/10 pt-16 pb-8" data-id="element-46">
      <div className="max-w-7xl mx-auto px-6" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6 mb-16" data-id="element-48">
          {/* Brand */}
          <div className="md:col-span-5 lg:col-span-4" data-id="element-49">
            <img src="https://cdn.magicpatterns.com/uploads/41yMwo1fNJJmW99NgWfnB6/Logo_New_Coneckta.png" alt="CONECKTA" className="h-8 object-contain mb-6" data-id="element-50" />
            <p className="text-muted text-sm leading-relaxed mb-6 max-w-xs" data-id="element-51">
              Automatización con IA para hacer crecer tu negocio.
            </p>
            <a href="mailto:info@coneckta.online" className="text-primary hover:text-white transition-colors text-sm font-medium" data-id="element-52">
              support@coneckta.online
            </a>
          </div>

          {/* Links */}
          <div className="md:col-span-7 lg:col-span-8 flex flex-wrap gap-10 md:justify-end" data-id="element-53">
            <div data-id="element-54">
              <h4 className="text-white font-semibold mb-4" data-id="element-55">Navegación</h4>
              <ul className="space-y-3" data-id="element-56">
                <li data-id="element-57">
                  <a href="#" className="text-muted hover:text-primary transition-colors text-sm" data-id="element-58">
                    Inicio
                  </a>
                </li>
                <li data-id="element-59">
                  <a href="#" className="text-muted hover:text-primary transition-colors text-sm" data-id="element-60">
                    Cómo Funciona
                  </a>
                </li>
                <li data-id="element-61">
                  <a href="#" className="text-muted hover:text-primary transition-colors text-sm" data-id="element-62">
                    Programa
                  </a>
                </li>
                <li data-id="element-63">
                  <a href="#" className="text-muted hover:text-primary transition-colors text-sm" data-id="element-64">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-primary/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-65">
          <p className="text-muted text-xs" data-id="element-66">
            © 2026 CONECKTA. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}